export class AccontoModel {
    public importo:number;
    public tokenIncasso:string;
    public codiceAS400:string;
    public id:number;
    public nomeAzienda?:string;
    public partitaIVA?:string;
    public idIncasso?:number;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/incassi/acconto.model.ts